import { combineReducers } from "redux";
import counterReducer from "./counterReducer";
import modalReducer from "./modalReducer";
import feedLayoutReducer from "./feedLayoutReducer";
import brandNavReducer from "./brandNavReducer";

const reducer = combineReducers({ counterReducer, modalReducer, feedLayoutReducer, brandNavReducer });

export default reducer;
